(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-delivery-popup"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const overlay = document.getElementById('delivery-popup-overlay');
    if (overlay) {
      overlay.style.display = 'flex';
    }
  });

  } catch(e) { console.error(e); }
})();
})();
